import {defineMessages} from 'react-intl';

export const messages = defineMessages({
    YES: {
        id: 'techDoc.powerSteering.option.yes',
        defaultMessage: 'Yes'
    },
    NO: {
        id: 'techDoc.powerSteering.option.no',
        defaultMessage: 'No'
    },
    VARIABLE: {
        id: 'techDoc.powerSteering.option.variable',
        defaultMessage: 'Variable'
    },
});

export default messages;
